export const dateFormat = "yyyy-MM-dd'T'HH:mm:ss";
export const timeFormat = 'HH:mm';
export const shortDateOnly = 'dd.MM.yyyy';
export const longDateOnly = 'EEEE, d MMMM yyyy';
